import React from 'react';
import styles from './Style.module.css';

export default function Chips({ color, text }) {
  return <span className={`${styles.base} ${styles[color]}`}>{text}</span>;
}
